module.exports = __webpack_public_path__ + "img/left-circle.40c09c8a.svg";